<template>
  <div class="col" style="margin-top: 150px">
    <div class="row" style="display: flex; justify-content: space-around;">
      <b-card
        class="mv-card"
        header-class="text-center"
        title=""
        style="font-size: 24px; margin: 2px; width: 100%; background-color: var(--mv-header-bg-color);">
        <template v-slot:header>
          Events
        </template>
        <glcwc-content-event-list
          inst-key="WFlIywMGaf1AqrLVAErIfQ"
          tag-list-filter="upcomming" text-color="#A569BD" />
      </b-card>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Events',
  created () {
    /* eslint quote-props: ["error", "as-needed", { "unnecessary": false }] */
    this.$tracker('event', 'screen_view', {
      'app_name': 'magiv',
      'screen_name': 'Events'
    })
  },
  components: {
  }
}
</script>
<style scoped>
.cmpn-card-item {
  display: flex;
  flex: 1 0 auto;
  min-width: 300px;
  /* max-width: 600px; */
  width: 45%;
}
</style>
